module.exports = __webpack_public_path__ + "img/logo.79fa581c.svg";